__turbopack_context__.v({
  "container": "Imprint-module-scss-module__nQG1lG__container",
  "links-wrapper": "Imprint-module-scss-module__nQG1lG__links-wrapper",
});
